// src/Splash.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Box, Typography } from "@mui/material";

const Splash = () => {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate("/record");
  };

  return (
    // <div className="app">
    //   <h1>Welcome</h1>
    //   <button
    //     style={{
    //       padding: "10px 20px",
    //       fontSize: "16px",
    //     }}
    //     onClick={handleStart}
    //   >
    //     Get Started
    //   </button>
    // </div>
    <Container
      maxWidth="sm"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        // backgroundColor: '#f5f5f5'
      }}
    >
      <Box
        textAlign="center"
        p={5}
        boxShadow={3}
        borderRadius={8}
        bgcolor="white"
      >
        <Typography
          variant="h3"
          gutterBottom
          style={{
            marginBottom: "20px",
            fontWeight: "bold",
            color: '#24285c',
          }}
        >
          Welcome to the App
        </Typography>
        <Button
          variant="contained"
          onClick={handleStart}
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            backgroundColor:'#fa690f',
            fontWeight: "700",
            borderRadius:20
          }}
        >
          Get Started
        </Button>
      </Box>
    </Container>
  );
};

export default Splash;
